export const categories = [
  {
    name: 'Category',
    url: '/base/category',
    icon: 'fa fa-cube'
  },
  {
    name: 'Create Category',
    url: '/base/category/create',
    icon: 'icon-plus'
  }
];
